






















import Enumerable from "linq";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { DateEditableMixin, StandardOption } from "./mixins";
import OptionDropDownSelector from "./OptionDropDownSelector.vue";
import ComboBoxSelector from "../../../components/system/selectors/ComboBoxSelector.vue";

@Component({
  components: {
    OptionDropDownSelector,
    ComboBoxSelector,
  }
})
export default class YearAsJapaneseCalendarEditor extends Mixins(DateEditableMixin) {
  @Prop()
  isEditable: boolean;

  $refs!: {
    optionSelector: OptionDropDownSelector;
  };

  data(): any {
    return {
      eras: Enumerable.from(this.$configuration.system.date.japaneseEras)
        .select(m => new StandardOption<string>(m.name, m.name))
        .toArray(),
      isJapaneseCalendarEditable: this.isEditable,
    };
  }
  eras: StandardOption<string>[];

  get startYear(): number {
    return Number(this.editingYearAsJapaneseCalendar) - this.$configuration.system.date.years.count.past; // 手入力したときに文字列になるときがあるので明示的に数値型にする
  }

  get endYear(): number {
    return Number(this.editingYearAsJapaneseCalendar) + this.$configuration.system.date.years.count.future; // 手入力したときに文字列になるときがあるので明示的に数値型にする
  }

  get japaneseYears(): number[] {
    return Enumerable.rangeTo(this.endYear, this.startYear)
      .where(y => y > 0)
      .toArray();
  }

  setFocus(): void {
    if (this.$refs.optionSelector) {
      this.$refs.optionSelector.setFocus();
    }
  }

  @Watch("isEditable")
  onIsEditableUpdated(newValue: boolean, oldValue: boolean) {
    this.isJapaneseCalendarEditable = newValue;
  }
}
